var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-item post-work-note"},[(_vm.post)?_c('post-user-header',{attrs:{"post":_vm.post}}):_vm._e(),_vm._v(" "),(_vm.post.title || _vm.post.text)?_c('text-wap',{attrs:{"post":_vm.post}}):_vm._e(),_vm._v(" "),(_vm.post)?_c('post-meta-info',{attrs:{"post":_vm.post}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d963512","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/post/PostText.vue
// module id = 1575
// module chunks = 0